import client from './client';

// ── 统计 ──
export const getStats = () => client.get('/admin/stats/');

// ── 用户管理 ──
export const getUsers = (params) => client.get('/admin/users/', { params });
export const editUser = (id, data) => client.patch(`/admin/users/${id}/edit/`, data);
export const getUserEnterpriseOptions = () => client.get('/admin/users/enterprise-options/');
export const toggleUserActive = (id) => client.post(`/admin/users/${id}/toggle_active/`);
export const toggleEngineerMode = (id) => client.post(`/admin/users/${id}/toggle_engineer_mode/`);
export const deleteMember = (id) => client.post(`/admin/users/${id}/delete_member/`);
// Phase G (2026-04-29)：批量软删除成员（best-effort）
export const bulkDeleteMembers = (ids) =>
  client.post('/admin/users/bulk_delete_member/', { ids });
// Phase C (2026-04-23)：Admin 改用户工作方向
export const updateUserWorkDirection = (id, work_direction) =>
  client.post(`/admin/users/${id}/update_work_direction/`, { work_direction });
// 超管设置讲师角色 (instructor-role-upgrade): personal ↔ instructor
// 仅超管可调用,后端有完整边界校验
export const setUserRole = (id, role) =>
  client.post(`/admin/users/${id}/set_role/`, { role });

// ── 用户回收站 ──
export const getUserRecycleBin = () => client.get('/admin/users/recycle-bin/');
export const restoreUser = (id) => client.post(`/admin/users/recycle-bin/${id}/restore/`);
export const permanentDeleteUser = (id) => client.delete(`/admin/users/recycle-bin/${id}/destroy/`);
export const bulkPermanentDeleteUsers = (ids) =>
  client.post('/admin/users/recycle-bin/bulk_destroy/', { ids });

// ── 企业管理 ──
export const getEnterprises = (params) => client.get('/admin/enterprises/', { params });
export const getEnterprise = (id) => client.get(`/admin/enterprises/${id}/`);
export const createEnterprise = (data) => client.post('/admin/enterprises/', data);
export const updateEnterprise = (id, data) => client.patch(`/admin/enterprises/${id}/`, data);
export const updateEnterpriseReportActions = (id, policy) =>
  client.patch(`/admin/enterprises/${id}/report-actions/`, { policy });
// Legacy export retained for older callers during rolling deployment.
export const updateEnterpriseLearningPlatform = (id, enabled) =>
  client.patch(`/admin/enterprises/${id}/learning-platform/`, { enabled });
export const deleteEnterprise = (id) => client.delete(`/admin/enterprises/${id}/`);
export const activateEnterprise = (id) => client.post(`/admin/enterprises/${id}/activate/`);
export const deactivateEnterprise = (id) => client.post(`/admin/enterprises/${id}/deactivate/`);

// ── 班级分流（class-stream，仅超管）──
export const getEnterpriseClasses = (entId) => client.get(`/admin/enterprises/${entId}/classes/`);
export const createEnterpriseClass = (entId, data) => client.post(`/admin/enterprises/${entId}/classes/`, data);
export const renameEnterpriseClass = (entId, classId, data) =>
  client.patch(`/admin/enterprises/${entId}/classes/${classId}/`, data);
export const disableEnterpriseClass = (entId, classId) =>
  client.post(`/admin/enterprises/${entId}/classes/${classId}/disable/`);
export const reactivateEnterpriseClass = (entId, classId) =>
  client.post(`/admin/enterprises/${entId}/classes/${classId}/reactivate/`);
export const transferEnterpriseClassMembers = (entId, classId, data) =>
  client.post(`/admin/enterprises/${entId}/classes/${classId}/transfer-members/`, data);
export const enableEnterpriseClasses = (entId, data) =>
  client.post(`/admin/enterprises/${entId}/classes/enable/`, data);
export const disableEnterpriseClasses = (entId) =>
  client.post(`/admin/enterprises/${entId}/classes/disable/`);

// ── 维度管理（V4 F.1：可配置维度）──
// V4 设计决策:
// - code 是稳定锚点 (创建时填, 之后不能改). 后端会拦 PATCH code 改动.
// - 删除不开放, 后端返回 405. 软停用走 PATCH is_active=false.
export const getDimensions = (params) => client.get('/admin/dimensions/', { params });
export const createDimension = (data) => client.post('/admin/dimensions/', data);
export const updateDimension = (id, data) => client.patch(`/admin/dimensions/${id}/`, data);
// V4 reorder: 批量改 sort_order. body = {order: [{id, sort_order}, ...]}.
export const reorderDimensions = (order) => client.post('/admin/dimensions/reorder/', { order });
// @deprecated V4 起后端返回 405. 保留导出避免破坏 import, 但调用必失败.
export const deleteDimension = (id) => client.delete(`/admin/dimensions/${id}/`);

// ── 维度介绍图管理（V4 F.2 / M24）──
// 后端: apps/dimensions/dim_intro_views.py (IsAdminRole 仅 admin/superadmin; current/ 公共可读)
// 上传必传 image_pc, 可选 image_mobile; 自动 bump version + 设 active + 关旧 active
export const getDimIntroImages = (params) =>
  client.get('/admin/dim-intro-images/', { params });
export const getDimIntroImageCurrent = () =>
  client.get('/admin/dim-intro-images/current/');
export const uploadDimIntroImage = (formData) =>
  client.post('/admin/dim-intro-images/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
export const activateDimIntroImage = (id) =>
  client.post(`/admin/dim-intro-images/${id}/activate/`);
export const deleteDimIntroImage = (id) =>
  client.delete(`/admin/dim-intro-images/${id}/`);
// 回滚到默认: 把所有 is_active 置 false → 首页 fallback 到默认 8 卡片网格
// 历史版本图本身不删, 之后还能 activateDimIntroImage(id) 把任意一版换回来
export const restoreDimIntroImageDefault = () =>
  client.post('/admin/dim-intro-images/restore_default/');

// ── 风险模板管理（V4 F.4 / M23）──
// 后端: apps/enterprises/admin_risk_template_views.py (IsAdminRole 仅 admin/superadmin)
// 风格与 admin.js 其它块一致: 返回 axios response, 调用方取 .data。
export const getRiskTemplates = (params) =>
  client.get('/admin/risk-templates/', { params });
export const createRiskTemplate = (data) =>
  client.post('/admin/risk-templates/', data);
export const updateRiskTemplate = (id, data) =>
  client.patch(`/admin/risk-templates/${id}/`, data);
export const deleteRiskTemplate = (id) =>
  client.delete(`/admin/risk-templates/${id}/`);

// ── V4 M22: Prompt 后台（F.3）──
// 后端: apps/ai_engine/admin_prompt_views.py (IsAdminRole, enterprise_admin 403)
// 6 段 + 5 道安全网（版本控制 / 一键回滚 / 真 AI 预览 / auto fallback / 占位符 reference）
export const getPromptSegments = () => client.get('/admin/prompts/segments/');
export const getPromptSegmentDetail = (segment, params) =>
  client.get(`/admin/prompts/segments/${segment}/`, { params });
export const createPromptVersion = (segment, data) =>
  client.post(`/admin/prompts/segments/${segment}/versions/`, data);
export const activatePromptVersion = (segment, version) =>
  client.post(`/admin/prompts/segments/${segment}/activate/`, { version });
export const previewPromptSegment = (segment, prompt_text) =>
  client.post(`/admin/prompts/segments/${segment}/preview/`, { prompt_text });
export const getPromptPlaceholders = () =>
  client.get('/admin/prompts/placeholders/');
export const getPromptNotifications = () =>
  client.get('/admin/prompts/notifications/');
export const ackPromptNotification = (id) =>
  client.post(`/admin/prompts/notifications/${id}/ack/`);

// ── 题库管理 ──
export const getQuestions = (params) => client.get('/admin/questions/', { params });
export const getQuestion = (id) => client.get(`/admin/questions/${id}/`);
export const createQuestion = (data) => client.post('/admin/questions/', data);
export const updateQuestion = (id, data) => client.patch(`/admin/questions/${id}/`, data);
export const deleteQuestion = (id) => client.delete(`/admin/questions/${id}/`);
export const toggleQuestionActive = (id) => client.post(`/admin/questions/${id}/toggle_active/`);
export const bulkDeleteQuestions = (ids) => client.post('/admin/questions/bulk_delete/', { ids });

// ── 回收站 ──
export const getRecycleBin = () => client.get('/admin/questions/recycle-bin/');
export const restoreQuestion = (id) => client.post(`/admin/questions/recycle-bin/${id}/restore/`);
export const permanentDeleteQuestion = (id) => client.delete(`/admin/questions/recycle-bin/${id}/destroy/`);
export const bulkRestoreQuestions = (ids) => client.post('/admin/questions/recycle-bin/bulk_restore/', { ids });
export const importQuestionsExcel = (file) => {
  const form = new FormData();
  form.append('file', file);
  return client.post('/admin/questions/import_excel/', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const getQuestionImportBatches = (params) =>
  client.get('/admin/questions/import_batches/', { params });
export const getQuestionImportBatchStatus = (batchId) =>
  client.get('/admin/questions/import_batch_status/', { params: { batch_id: batchId } });
export const importBusinessQuestionsExcel = (file) => {
  const form = new FormData();
  form.append('file', file);
  return client.post('/admin/questions/import_business_excel/', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const reviseQuestionImportBatch = (batchId, file) => {
  const form = new FormData();
  form.append('batch_id', batchId);
  form.append('file', file);
  return client.post('/admin/questions/revise_import_batch/', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const retryQuestionImportBatch = (batchId) =>
  client.post('/admin/questions/retry_import_batch/', { batch_id: batchId });
export const confirmQuestionImportBatch = (batchId) =>
  client.post('/admin/questions/confirm_import_batch/', { batch_id: batchId });
export const activateQuestionImportBatch = (batchId) =>
  client.post('/admin/questions/activate_import_batch/', { batch_id: batchId });
export const downloadQuestionImportBatch = (batchId) =>
  client.get('/admin/questions/download_import_batch/', {
    params: { batch_id: batchId }, responseType: 'blob',
  });
export const downloadQuestionTemplate = () =>
  client.get('/admin/questions/download_template/', { responseType: 'blob' });
export const downloadBusinessQuestionTemplate = () =>
  client.get('/admin/questions/download_business_template/', { responseType: 'blob' });
// V5 M3：题库编辑表单下拉数据（场景标签白名单）
export const getQuestionMeta = () => client.get('/admin/questions/meta/');

// ── AI 策略配置 ──
export const getAIStrategies = () => client.get('/admin/ai-strategy/');
export const getAIStrategy = (id) => client.get(`/admin/ai-strategy/${id}/`);
export const createAIStrategy = (data) => client.post('/admin/ai-strategy/', data);
export const updateAIStrategy = (id, data) => client.put(`/admin/ai-strategy/${id}/`, data);
export const deleteAIStrategy = (id) => client.delete(`/admin/ai-strategy/${id}/`);
export const copyAIStrategy = (id) => client.post(`/admin/ai-strategy/${id}/copy/`);
export const setDefaultAIStrategy = (id) => client.post(`/admin/ai-strategy/${id}/set_default/`);
export const bindEnterpriseStrategy = (enterpriseId, strategyId) =>
  client.patch(`/admin/enterprises/${enterpriseId}/`, { strategy: strategyId || null });

// ── 用户测评历史 ──
export const getUserAssessments = (userId) =>
  client.get(`/admin/users/${userId}/assessments/`);

// ── 报告详情 ──
export const getAdminReportDetail = (assessmentId) =>
  client.get(`/admin/reports/${assessmentId}/detail/`);

export const getAdminAssessmentData = (params) =>
  client.get('/admin/reports/assessment-data/', { params });

export async function downloadAdminAssessmentData(params) {
  try {
    const response = await client.get(
      '/admin/reports/assessment-data/export/',
      { params, responseType: 'blob' },
    );
    const url = URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'assessment_data.csv';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
    return { ok: true };
  } catch (error) {
    let detail = error?.response?.data?.detail;
    if (error?.response?.data instanceof Blob) {
      try {
        const body = JSON.parse(await error.response.data.text());
        detail = body?.detail;
      } catch (_) {
        detail = null;
      }
    }
    return { ok: false, error: detail || error?.message || '导出失败，请稍后重试' };
  }
}

export async function downloadAdminAnswerTiming(assessmentId) {
  try {
    const response = await client.get(
      `/admin/reports/${assessmentId}/timing/export/`,
      { responseType: 'blob' },
    );
    const url = URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = `assessment_${assessmentId}_answer_timing.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
    return { ok: true };
  } catch (error) {
    let detail = error?.response?.data?.detail;
    if (error?.response?.data instanceof Blob) {
      try {
        const body = JSON.parse(await error.response.data.text());
        detail = body?.detail;
      } catch (_) {
        detail = null;
      }
    }
    return { ok: false, error: detail || error?.message || '导出失败，请稍后重试' };
  }
}

// ── 企业管理员：查看当前绑定策略 ──
export const getEnterpriseCurrentStrategy = () =>
  client.get('/admin/ai-strategy/enterprise-current/');
